import {
  RESET_FAST_JOB_DIALOGS,
  SET_DIALOG_FAST_JOB,
} from '@/store/mutation-types.js';

const actions = {
  setDialogFastJob({ commit }, value) {
    commit(SET_DIALOG_FAST_JOB, value);
  },

  reset({ commit }) {
    commit(RESET_FAST_JOB_DIALOGS);
  },
};

export default actions;
